//
import WhInventoryModel from "@/models/Warehouse/WhInventory"

/**
* 
*/
export default class WhInventory extends WhInventoryModel {

  //
  static includes = [
    "g_state",
    //"g_user_supervisor.hr_employee",
    "g_user_warehouseman.hr_employee",
    //"wh_detail_inventories.wh_product",
    //"wh_stock_adjust",
    "wh_warehouse",
  ]

  confirm_raw() {
  	return WhInventoryModel
  		.modeler()
  		.find(this.id)
  		.then(e => e.confirm())
  }
}